import Axios, { AxiosRequestConfig } from 'axios';
import env from 'env';
import bus, { AuthEventTypes } from 'modules/bus';
import drCredentialsService from '../services/drCredentialsService';
import { delay, getMaxRetryCount, isRetryableError } from 'retryHelper';

const httpClient = Axios.create({
  baseURL: `${env.SERVER_ENDPOINT}/api/`,
});

const setToken = (config: AxiosRequestConfig) => {
  const { token } = drCredentialsService;

  if (token && config.method !== 'OPTIONS') {
    config.headers.Authorization = `Bearer ${token}`;
  }
};

httpClient.interceptors.request.use(
  async function (config) {
    // Do something before request is sent
    // If the header does not contain the token and the url not public, redirect to login

    setToken(config);

    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

httpClient.interceptors.response.use(null, async (error) => {
  const { response, config } = error;

  if (response?.status === 403) {
    bus.broadcastEvent(AuthEventTypes.DR_FORBIDDEN_SIGNAL);
    return Promise.reject(error);
  }

  if (response?.status === 401) {
    bus.broadcastEvent(AuthEventTypes.DR_LOGOUT_SIGNAL);
    return Promise.reject(error);
  }

  if (isRetryableError(error)) {
    config.__retryCount = config.__retryCount || 0;

    if (config.__retryCount < getMaxRetryCount(config)) {
      config.__retryCount += 1;

      await delay(config.__retryCount);

      return httpClient(config);
    }
  }

  return Promise.reject(error);
});

export default httpClient;
